import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";

import { ButtonViewTypes } from "../../components";
import { CoreReportTable } from "../core_report_table";
import { CoreReportChart } from "../core_report_chart";
import { CoreReportActionBar } from "../core_report_action_bar";
import { CoreReportActionBarLeft } from "../core_report_action_bar_left";
import { CoreReportTitleBar } from "../core_report_title_bar";
import { REPORT_ACTIONS, REPORT_STATUS } from "../_utils/constants";

const CoreReport = ({
  width,
  height,
  data,
  dataMode,
  view,
  theme,
  isSelected,
  onReportAction,
  showLegend,
  isTooltipSplit,
  isFullScreen
}) => {
  const onClickTitleBar = () => {
    onReportAction(REPORT_ACTIONS.SELECT);
  };

  const onActionButtonClick = action => {
    onReportAction(action);
  };

  // console.log("report data", data);
  const loading =
    data && data.status && data.status === REPORT_STATUS.LOADING ? true : false;

  let containerProps = {};
  if (isFullScreen && isSelected) {
    height = window.innerHeight - 100;
    width = "100%";
    containerProps = {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: "1000"
    };
  }
  return (
    <div
      style={{
        //backgroundColor: "#fff",
        marginTop: "16px",
        marginRight: "8px"
        // boxShadow: "0px 0px 10px #ccc"
      }}
    >
      <Row type="flex" justify="space-around" align="middle">
        <Col xs={1} style={{ textAlign: "center" }}>
          <CoreReportActionBarLeft onAction={onActionButtonClick} />
        </Col>
        <Col xs={23}>
          <div
            style={{
              backgroundColor: "#fff",
              padding: "8px",
              borderRadius: "4px",
              border: "8px solid",
              borderColor: isSelected ? "#13a89e" : "#efefef",
              boxShadow: "0px 0px 10px 0px #ccc",
              ...containerProps
            }}
          >
            <CoreReportActionBar
              isActive={isSelected}
              onAction={onActionButtonClick}
              reportData={data.data}
              isFullScreen={isFullScreen && isSelected}
            />
            <CoreReportTitleBar
              isActive={isSelected}
              reportName={data.title}
              reportSubtitle={data.subtitle}
              onClick={onClickTitleBar}
            />
            {view === ButtonViewTypes.Table && (
              <div style={{ padding: "8px" }}>
                <CoreReportTable
                  loading={loading}
                  tableWidth={width}
                  tableHeight={height}
                  data={data.data}
                  dataMode={dataMode}
                />
              </div>
            )}
            {view === ButtonViewTypes.Chart && (
              <CoreReportChart
                loading={loading}
                // chartWidth={width}
                chartHeight={height}
                data={data.data}
                dataMode={dataMode}
                theme={theme}
                showLegend={showLegend}
                isTooltipSplit={isTooltipSplit}
              />
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

CoreReport.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  data: PropTypes.object,
  dataMode: PropTypes.string,
  view: PropTypes.string.isRequired,
  theme: PropTypes.object,
  isSelected: PropTypes.bool,
  onReportAction: PropTypes.func.isRequired,
  showLegend: PropTypes.bool.isRequired,
  isTooltipSplit: PropTypes.bool.isRequired,
  isFullScreen: PropTypes.bool.isRequired
};

export default CoreReport;



// WEBPACK FOOTER //
// ./src/views/core/core_report/CoreReport.jsx